module.exports = __webpack_public_path__ + "media/images/blobs/blob-purple-ed5ac83ac77613f8ec220aa9dbf71c4b.svg";